import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { PersonTypes } from '@frontend/api-person';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, styles, Text } from '@frontend/design-system';
import { formatPhoneNumber } from '../../utils/formatting-utils';

type Props = {
  item: Partial<PersonTypes.Person>;
  onClick: () => void;
  active?: boolean;
};
export const AutocompletePerson = forwardRef<HTMLLIElement, Props>(({ item, onClick, active }, ref) => {
  return (
    <li
      className='person'
      key={item.PersonID}
      ref={ref}
      css={{
        background: active ? theme.colors.neutral70 : 'transparent',
      }}
    >
      <PopoverMenuItem
        css={{
          background: 'transparent',
        }}
        className='list-item'
        onClick={onClick}
        active={active}
      >
        <Text color='white' css={styles.multilineTruncate(2)}>
          {item.FirstName} {item.LastName}
        </Text>
        <Text
          size='small'
          css={css`
            color: ${theme.colors.neutral30};
          `}
        >
          {formatPhoneNumber(item.MobilePhone ?? item.HomePhone ?? '')}
        </Text>
      </PopoverMenuItem>
    </li>
  );
});

AutocompletePerson.displayName = 'AutocompletePerson';
